export default "__VITE_ASSET__BJvq80G___"